import logo from "../assets/logo.png"
import { MENU, NAME, PHONE } from "../constants";
import { FaPhoneVolume } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import DropdownMenu from '../components/dropdown';
import { Link, useLocation } from 'react-router-dom';

function Header() {
    const CONTACTS = [
        {
            icon: <FaPhoneVolume className="main-color text-lg" />,
            label: PHONE,
            link: "tel:+256200906279",
        },
        {
            icon: <MdEmail className="main-color text-lg" />,
            label: "customercare@tlmcf.org",
            link: "mailto:customercare@tlmcf.org",
        },
    ];


    const location = useLocation();
    const { pathname } = location;



    return (
        <header className="sticky top-0 z-10 bg-white">
            <div className="border-b py-2.5 text-tiny">
                <div className=" flex flex-col gap-4 lg:flex-row lg:justify-between container">
                    <div className="flex justify-between">
                        <div className="flex gap-6">
                            {CONTACTS.map((c, i) => (
                                <div key={i} className="flex items-center gap-2">
                                    {c.icon}
                                    <p>{c.label}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="hidden lg:flex gap-2 items-center">
                        <FaLocationDot className="main-color text-lg" />
                        <p>Ober Village, Zuma parish, Myene Sub-County, Oyam District</p>
                    </div>
                </div>
            </div>
            <div className="border-b">
                <div className="flex justify-between items-center container">
                    <Link href={"/"} className="flex items-center gap-1">
                        <img
                            src={logo}
                            alt={NAME}
                            className="object-contain h-20"
                        />
                        <div>
                            <p className="font-bold text-2xl">
                                <span className="main-color">Touchlife</span>
                            </p>
                            <p className="capitalize text-sm mt-[-2px]">
                                Medical care foundation
                            </p>
                        </div>
                    </Link>
                    <div className="hidden xl:flex gap-3 items-center">
                        {MENU.map((m, i) => {
                            if (m.links.length === 0)
                                return (
                                    <Link key={i} to={"/" + m.link}>
                                        <div
                                            className={`px-3 py-5 capitalize text-base ${pathname.split("/")[1] === m.link
                                                ? "active-link"
                                                : "inactive-link"
                                                }`}
                                        >
                                            {m.label}
                                        </div>
                                    </Link>
                                );
                            return <DropdownMenu key={i} menu={m} />;
                        })}
                    </div>
                    <div className="flex items-center gap-4">
                        <Link
                            href={"/contact"}
                            className="hidden md:block main-btn px-9  py-3.5 capitalize"
                        >
                            Partner with us
                        </Link>
                        {/* <Drawer /> */}
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header
